import { render, staticRenderFns } from "./RevenuesTypeInfo.vue?vue&type=template&id=6a406a26&"
import script from "./RevenuesTypeInfo.vue?vue&type=script&lang=js&"
export * from "./RevenuesTypeInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports